import { render, staticRenderFns } from "./ShowsItem.vue?vue&type=template&id=273d831e&"
import script from "./ShowsItem.vue?vue&type=script&lang=js&"
export * from "./ShowsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports